import { useQuery } from '@tanstack/react-query';
import { readContract } from '@wagmi/core';

import { Address } from 'viem';

import { useAuth } from '@shared/common/providers/AuthProvider';
import { wagmiConfig } from '@shared/common/providers/Web3Provider/wagmi';
import { DEFAULT_TARGET_CHAIN } from '@shared/constants';

import { PredictionEntry } from '../../model/PredictionEntry';
import { PREDICTIONS_CONTRACT } from '../config/contract';
import { getQueryKey } from '../config/query';
import { dataMapper } from './dataMapper';

const fetchPredictionEntries = async (walletAddress?: Address): Promise<PredictionEntry[]> => {
  if (!walletAddress) {
    return [];
  }

  try {
    const rounds = await readContract(wagmiConfig, {
      ...PREDICTIONS_CONTRACT,
      chainId: DEFAULT_TARGET_CHAIN.id,
      functionName: 'getWalletAndRounds',
      args: [walletAddress],
    });

    if (!Array.isArray(rounds)) {
      throw new Error('incorrect rounds');
    }

    return dataMapper(rounds);
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const usePredictionEntries = () => {
  const { userEvmWallet } = useAuth();
  const walletAddress = userEvmWallet?.attributes.address;

  return useQuery({
    queryKey: getQueryKey('prediction-rounds', walletAddress),
    queryFn: () => fetchPredictionEntries(walletAddress),
  });
};
